import { Heading, Separator, Text, VStack } from "@chakra-ui/react";
import React from "react";

interface FormContainerProps {
  children: React.ReactNode;
  maxWidth?: string;
  heading: string;
  description?: string;
}

function FormContainer({
  children,
  maxWidth = "500px",
  heading,
  description,
  ...props
}: FormContainerProps) {
  return (
    <VStack
      p={{ base: 6, md: 10 }}
      borderWidth={{ base: 0, md: 1 }}
      borderRadius="2xl"
      borderColor="rgba(0, 209, 193, 0.1)"
      width="600px"
      maxWidth={maxWidth}
      gap={6}
      bg="white"
      boxShadow={{
        base: "none",
        md: "0 4px 20px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 209, 193, 0.05)",
      }}
      transition="all 0.3s ease"
      _hover={{
        boxShadow: {
          md: "0 8px 30px rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(0, 209, 193, 0.1)",
        },
      }}
      {...props}
    >
      <VStack>
        <Heading size={"2xl"}>{heading}</Heading>
        <Text fontSize={"sm"} opacity={0.5}>{description}</Text>
      </VStack>
      <Separator my={2} w={"full"} />
      {children}
    </VStack>
  );
}

export default FormContainer;
